import { configureStore } from "@reduxjs/toolkit";
import wishlistSlice from "./features/wishlistSlice";
import wishlistItemsslice from "./features/fetchwishListitem";
import cartReducer from "./features/cartSlice";
import cartitemsSlice from "./features/cartitemsSlice";
import classificationSlice from "./features/classificationSlice";
import compareReducer from "./features/compareSlicetwo";
import bannerReducer from "./features/bannerSlice";
import Testimonialreducer from "./features/testimonialSlice";
import VideosliceReducer from "./features/videoSlice";
import BackgroundbannerReducer from "./features/backgroundBannerslice";
import ComboofferReducer from "./features/comboOfferSlice";
import footerProductcategoryReducer from "./features/footerproductorcategorySlice";
import advertisementhomereducer from "./features/advertisementhomeSlice";
import footerreducer from "./features/footerSlice";
import categoryreducer from "./features/Categoryslice";
import quicllinksreducer from "./features/QuickSlice";
import QuickLink from "./Components/Homepage/QuickLink";
const store = configureStore({
  reducer: {
    wishlist: wishlistSlice,
    wishlistItems: wishlistItemsslice,
    cart: cartReducer,
    cartitems: cartitemsSlice,
    classificationlist: classificationSlice,
    compare: compareReducer,
    banner: bannerReducer,
    testimonial: Testimonialreducer,
    videoslice: VideosliceReducer,
    backgroundbanner: BackgroundbannerReducer,
    combooffer: ComboofferReducer,
    footerproduct: footerProductcategoryReducer,
    advertisementhome: advertisementhomereducer,
    footerdetails: footerreducer,
    category: categoryreducer,
    quicklink: quicllinksreducer,
  },
});

export default store;
